import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { I18nModule } from 'app/core/services/i18n/i18n.module';
import { RangeFieldComponent } from 'app/shared/components/range-field/range-field.component';
import { NumericExpressionModule } from 'app/shared/directives/numeric-expression/numeric-expression.module';

@NgModule({
  imports: [CommonModule, FormsModule, TranslateModule, I18nModule, NumericExpressionModule],
  declarations: [RangeFieldComponent],
  exports: [RangeFieldComponent],
})
export class RangeFieldModule {}
